@if (config.numberFormat !== 'phoneNumber' && !config.inputControls && !config.isPhoneNumber && !decimalNumbersOnly ) {
  <div [formGroup]="group" [hidden]="config.hide"
    class="{{ gs.isVersion2 ? '' : 'form-input'}} {{config.class}}">
    @if (config.formInputIcon) {
      <span class="rs-me-5">
        <i class="{{config.formInputIcon}} seat-icon-color"></i>
      </span>
    }
    @if (!config.appearanceOutline && !config.icon && config.label) {
      <div for="" class="default-sub-header text-label">{{config.label | translate}} @if (config.isMandatory) {
        <span class="mandatory-field">*</span>
      }</div>
    }
    <mat-form-field class="basic-input-field " [ngClass]="{'input-with-boundary':config.appearance}" appearance="outline">
      @if (!config.appearanceOutline && config.icon && config.label) {
        <mat-label class="select-label">
          <i class="view-icon {{config.icon}}"></i>
          <span>{{config.label | translate}}</span>
        </mat-label>
      }
      @if (!config.icon && config.label && config.appearanceOutline) {
        <mat-label>{{config.label | translate}}</mat-label>
      }
      @if (config.inputType !== 'number') {
        <input matInput placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'"
          [formControlName]="config.name" [attr.name]="config.name" [errorStateMatcher]="config.appearanceOutline ? false : matcher"
          [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'"
          [ngClass]="{'adjusted-width':config.icon1}" (keyup)="onKeyup($event)" [attr.aria-label]="config.ariaLabel ? (config.ariaLabel | translate).replace('*','') : null">
      }
      @if (config.inputType == 'number') {
        <input matInput placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'"
          [formControlName]="config.name" [attr.name]="config.name" [errorStateMatcher]="config.appearanceOutline ? false : matcher"
          [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'"
          [ngClass]="{'adjusted-width':config.icon1}" [min]="0" [attr.aria-label]="config.ariaLabel ? (config.ariaLabel | translate).replace('*','') : null">
      }
      @if (config.icon1 && group.controls[FormControlName].value && !config.showIconAlways) {
        <i class="view-icon {{config.icon1}} seat-icon-color"
        (click)="iconClick($event)"></i>
      }
      @if (config.icon1 && config.showIconAlways) {
        <i class="view-icon {{config.icon1}} seat-icon-color"
        (click)="iconClick($event)"></i>
      }
      @if ( !group.controls[FormControlName].hasError('email') && group.controls[FormControlName].hasError('pattern')) {
        <mat-error
          >
          {{'invalidText' | translate}}
        </mat-error>
      }
      @if (!group.controls[FormControlName].hasError('pattern') && group.controls[FormControlName].hasError('required') && config.showErrorText &&  group.controls[FormControlName].dirty) {
        <mat-error
          >
          {{config.errorMessage | translate}}
        </mat-error>
      }
      @if ((group.controls[FormControlName].value && (group.controls[FormControlName].hasError('email')) && group.controls[FormControlName].dirty && config.showErrorText)) {
        <mat-error
          >
          {{'invalidEmail' | translate}}
        </mat-error>
      }
      @if (!group.controls[FormControlName].hasError('pattern') && group.controls[FormControlName].value && group.controls[FormControlName].hasError('max')) {
        <mat-error
          >
          {{'errorPaidAmount' | translate}}
        </mat-error>
      }
      @if (group.controls[FormControlName].hasError('minlength') && group.controls[FormControlName].touched && config.showErrorText) {
        <mat-error
          >
          {{'minlengthValidationMessage' | translate: {charLength: config.charLength} }}
        </mat-error>
      }
    </mat-form-field>
  </div>
}

@if (config.numberFormat !== 'phoneNumber' && inputControls && !config.isPhoneNumber && !decimalNumbersOnly) {
  <div [formGroup]="group" class="{{ gs.isVersion2 ? '' : 'form-input'}} {{config.class}}">
    <div for="" class="default-form-field text-label">{{config.label | translate}} @if (config.isMandatory) {
      <span class="mandatory-field">*</span>
    }</div>
    <span class="controls-icon" [ngClass]="{'disabled-icon':config.decreaseDisabled}" (click)="decreaseClicked($event)">-</span>
    <mat-form-field class="basic-input-field " [ngClass]="{'input-with-boundary':config.appearance}" appearance="outline">
      <input matInput readonly placeholder="{{config.placeholder | translate}}"
        [type]="config.inputType? config.inputType:'text'" [formControlName]="config.name" [attr.name]="config.name"
        [errorStateMatcher]="matcher" [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'"
        [ngClass]="{'adjusted-width':config.icon1}" (keyup)="onKeyup($event)" [attr.aria-label]="config.ariaLabel ? (config.ariaLabel | translate).replace('*','') : null">
        @if (group.controls[FormControlName].hasError('pattern')) {
          <mat-error class="mt-4"
            >
            {{'invalidText' | translate}}
          </mat-error>
        }
      </mat-form-field>
      <span class="controls-icon" [ngClass]="{'disabled-icon':config.increaseDisabled}"
      (click)="increaseClicked($event)">+</span>
    </div>
  }
  @if ( config.numberFormat !== 'phoneNumber' && decimalNumbersOnly) {
    <div [formGroup]="group" class="{{ gs.isVersion2 ? '' : 'form-input'}} {{config.class}}">
      <mat-form-field class="basic-input-field" [ngClass]="config.class" appearance="outline">
        <mat-label class="select-label">{{config.label | translate}}</mat-label>
        @if (prefix) {
          <span matPrefix>{{prefix}} &nbsp;</span>
        }
        <input matInput placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'"
          [formControlName]="config.name" (keyup)="onKeyup($event)" [attr.name]="config.name"
          [maxlength]="config.charLength" [errorStateMatcher]="matcher"
          [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'" appDecimalsOnly [attr.aria-label]="config.ariaLabel ? (config.ariaLabel | translate).replace('*','') : null">
          @if (group.controls[FormControlName].hasError('pattern')) {
            <mat-error class="mt-4"
              >
              {{'invalidText' | translate}}
            </mat-error>
          }
          @if (group.controls[FormControlName].hasError('required') && config.showErrorText) {
            <mat-error>
              {{config.errorMessage | translate}}
            </mat-error>
          }
          @if (group.controls[FormControlName].hasError('minlength') && group.controls[FormControlName].touched && config.showErrorText) {
            <mat-error
              >
              Please enter a minimum of {{config.charLength}} characters.
            </mat-error>
          }
          @if (FormControlName == 'customSize' && group.controls[FormControlName].invalid && config.showErrorText) {
            <mat-error
              >
              {{config.errorMessage | translate}}
            </mat-error>
          }
          @if (FormControlName == 'refundAmountConfig' && group.controls[FormControlName].value && group.controls[FormControlName].hasError('max')) {
            <mat-error
              >
              {{'refundError' | translate}}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (config.numberFormat == 'phoneNumber' && !config.inputControls && !config.isPhoneNumber && !decimalNumbersOnly ) {
      <div [formGroup]="group" [hidden]="config.hide"
        class="{{ gs.isVersion2 ? '' : 'form-input'}} {{config.class}}">
        @if (config.formInputIcon) {
          <span class="rs-me-5">
            <i class="{{config.formInputIcon}} seat-icon-color"></i>
          </span>
        }
        @if (!config.appearanceOutline && !config.icon && config.label) {
          <div for="" class="default-sub-header text-label">{{config.label | translate}} @if (config.isMandatory) {
            <span class="mandatory-field">*</span>
          }</div>
        }
        <mat-form-field class="basic-input-field " [ngClass]="{'input-with-boundary':config.appearance}" appearance="outline">
          @if (!config.appearanceOutline && config.icon && config.label) {
            <mat-label class="select-label">
              <i class="view-icon {{config.icon}}"></i>
              <span>{{config.label | translate}}</span>
            </mat-label>
          }
          @if (!config.icon && config.label && config.appearanceOutline) {
            <mat-label>{{config.label | translate}}</mat-label>
          }
          @if (config.inputType !== 'number') {
            <input matInput  [maxlength]="dfs.requiredPhoneNumberLength$" placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'"
              [formControlName]="config.name" [attr.name]="config.name" [errorStateMatcher]="config.appearanceOutline ? false : matcher"
              [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'" [attr.aria-label]="config.ariaLabel ? (config.ariaLabel | translate).replace('*','') : null"
              [ngClass]="{'adjusted-width':config.icon1}" (keyup)="onKeyup($event)" phoneNumber>
          }
          @if (config.inputType == 'number') {
            <input matInput [maxlength]="dfs.requiredPhoneNumberLength$" placeholder="{{config.placeholder | translate}}" [type]="config.inputType? config.inputType:'text'"
              [formControlName]="config.name" [attr.name]="config.name" [errorStateMatcher]="config.appearanceOutline ? false : matcher"
              [attr.autocomplete]="config.autocomplete != undefined ? config.autocomplete : 'off'" [attr.aria-label]="config.ariaLabel ? (config.ariaLabel | translate).replace('*','') : null"
              [ngClass]="{'adjusted-width':config.icon1}" [min]="0" phoneNumber>
          }
          @if (config.icon1 && group.controls[FormControlName].value && !config.showIconAlways) {
            <i class="view-icon {{config.icon1}} seat-icon-color"
            (click)="iconClick($event)"></i>
          }
          @if (config.icon1 && config.showIconAlways) {
            <i class="view-icon {{config.icon1}} seat-icon-color"
            (click)="iconClick($event)"></i>
          }
          @if ( !group.controls[FormControlName].hasError('email') && group.controls[FormControlName].hasError('pattern')) {
            <mat-error
              >
              {{'invalidText' | translate}}
            </mat-error>
          }
          @if (!group.controls[FormControlName].hasError('pattern') && group.controls[FormControlName].hasError('required') && config.showErrorText &&  group.controls[FormControlName].dirty) {
            <mat-error
              >
              {{config.errorMessage | translate}}
            </mat-error>
          }
          @if ((group.controls[FormControlName].value && (group.controls[FormControlName].hasError('email')) && group.controls[FormControlName].dirty && config.showErrorText)) {
            <mat-error
              >
              {{'invalidEmail' | translate}}
            </mat-error>
          }
          @if (!group.controls[FormControlName].hasError('pattern') && group.controls[FormControlName].value && group.controls[FormControlName].hasError('max')) {
            <mat-error
              >
              {{'errorPaidAmount' | translate}}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }